<div class="details-view-container">
  <mat-card appearance="outlined">
    <mat-card-content class="card-content">
      <mat-tab-group class="details-tab-group">
        <mat-tab label="Details">
          <div class="search-professional">
            <button
              class="search-entity-button"
              mat-raised-button
              (click)="searchForIssuedEntity()"
              [matTooltip]="
                'Search for ' + (isProvider ? 'Provider' : 'Professional')
              "
            >
              <mat-icon>search</mat-icon>
              {{ issuedEntity?.name || discipline?.name }}
            </button>
          </div>

          <h4 class="inline mt-10" *ngIf="discipline?.type">
            <strong> Type: {{ discipline?.type }}</strong>
            <a
              *ngIf="
                formatUrl(discipline?.link) as disciplineUrl
              "
              [href]="disciplineUrl"
              [matTooltip]="disciplineUrl"
              target="_blank"
              class="link-with-icon"
              rel="noopener"
              aria-label="Opens in a new tab"
            >
              <mat-icon class="mat-icon-small">open_in_new</mat-icon>
            </a>
          </h4>

          <div class="discipline-info-group">
            <div class="inline" *ngIf="issuedEntity?.status">
              <p>
                <strong>Status: </strong>
                {{ issuedEntity?.status }}
              </p>
            </div>

            <div *ngIf="discipline?.location || issuedEntity?.['address3']">
              <mat-icon class="mat-icon-small">place</mat-icon>
              <strong>Location: </strong>
              <span
                >{{ discipline?.location || issuedEntity?.['address3'] }}</span
              >
            </div>

            <div *ngIf="discipline?.date">
              <mat-icon class="mat-icon-small">event</mat-icon>
              <strong>Date: </strong>
              <span>{{ discipline?.date | date : dateFormat }}</span>
            </div>

            <div *ngIf="discipline?.website?.province">
              <mat-icon class="mat-icon-small">public</mat-icon>
              <strong>Province: </strong>
              <span>{{ discipline?.website?.province }}</span>
            </div>

            <div *ngIf="discipline?.website?.benefit">
              <mat-icon class="mat-icon-small">favorite</mat-icon>
              <strong>Benefit: </strong>
              <span>{{ discipline?.website?.benefit }}</span>
            </div>

            <div *ngIf="discipline?.website?.profession">
              <mat-icon class="mat-icon-small">badge</mat-icon>
              <strong>Profession: </strong>
              <span>{{ discipline?.website?.profession }}</span>
            </div>

            <div *ngIf="discipline?.note">
              <mat-icon class="mat-icon-small">speaker_notes</mat-icon>
              <strong>Note: </strong><span>{{ discipline.note }}</span>
            </div>

            <div *ngIf="discipline?.note2">
              <mat-icon class="mat-icon-small">speaker_notes</mat-icon>
              <strong>Note2: </strong><span>{{ discipline.note2 }}</span>
            </div>

            <div class="last-updated" *ngIf="discipline?.lastUpdatedDate">
              <p>
                Last updated:
                {{ discipline?.lastUpdatedDate | date : dateFormat }}
              </p>
            </div>
          </div>
        </mat-tab>

        <mat-tab *ngIf="discipline?.documents?.length > 0">
          <ng-template mat-tab-label>
            <mat-icon class="concern-warning">warning</mat-icon>
            {{ discipline?.type || "Concern" }}
          </ng-template>

          <div *ngFor="let document of discipline?.documents" class="document-wrapper">

            <app-safe-html-viewer
            [matTooltip]="document?.url ? 'Download file: ' + document?.url : ''"
            [rawHtml]="getDocumentHtml(document)"
          ></app-safe-html-viewer>
          
          </div>
          
          <div class="last-updated" *ngIf="discipline?.lastUpdatedDate">
            <p>
              Last updated:
              {{ discipline?.lastUpdatedDate | date : dateFormat }}
            </p>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>
